/* Shopify Inbox's launcher and the theme's own bottom bars (the mobile dock, the sticky cart bar
   on product pages) all want the same corner. The launcher yields: it rides above whichever bar
   is showing and is hidden while a dialog is open, so two floating actions never compete.
   Measured on v3 (28.08): the widget ignores --shopify-agent-activator-offset, so its host is
   moved with a transform; the variable is still set for the day Shopify honours it. */

const BARS = 'mw-mobile-dock, mw-sticky-cart.is-shown, mw-landing-sticky.is-shown';
// Section bars that stick to the bottom only part of the time (the contact page's send bar on
// phones) mark themselves [data-bottom-bar]; they count only while they rest on the bottom edge
// or on a bar below them, never while they sit further up in the page.
const STICKY_BARS = '[data-bottom-bar]';
// The discount reminder (sections/newsletter-popup.liquid) floats at the left on the same bars. On
// a phone it spans the width, so the launcher climbs above it instead of covering its buttons.
// The teaser (a closed popup's ticket) takes the same place before a signup, so both count.
const PILL = '[data-npop-pill], [data-npop-teaser]';
const PILL_GAP = 16; // the reminder's distance to the bars (section-newsletter-popup.css)
// What the launcher must never cover: the product page's own buy buttons. It steps aside while one
// is under it (11.10: on a phone it sat on «Læg i kurv» after «Skift» scrolled back to the ladder).
const AVOID = '.pdp-buy .pform__add, .pdp-buy .shopify-payment-button, [data-chat-avoid]';
// The lowest stretch of the window, where the reminder and the launcher float. A task's bar
// anywhere in it (stuck or resting at the end of its step) is the thing at hand.
const LANE = 140;
const GAP = 12;
let frame = 0;
let rest = 24;
let lastReach = -1;
let settle = 0;

function place() {
  frame = 0;
  // How far the tallest showing bar reaches up from the bottom of the window.
  let reach = 0;
  let task = false;
  document.querySelectorAll(BARS).forEach((bar) => {
    const style = getComputedStyle(bar);
    if (style.display === 'none' || style.visibility === 'hidden') return;
    reach = Math.max(reach, window.innerHeight - bar.getBoundingClientRect().top);
  });
  document.querySelectorAll(STICKY_BARS).forEach((bar) => {
    const box = bar.getBoundingClientRect();
    if (!box.height || getComputedStyle(bar).position !== 'sticky') return;
    if (box.top < window.innerHeight && box.bottom > window.innerHeight - reach - LANE) task = true;
    if (box.bottom >= window.innerHeight - reach - 2) reach = Math.max(reach, window.innerHeight - box.top);
  });
  // Shared with other floating things: the reminder sits on --mw-bottom-reach and steps aside while
  // a task's own bar is in the lane (data-bottom-task).
  const root = document.documentElement;
  root.style.setProperty('--mw-bottom-reach', `${Math.ceil(reach)}px`);
  root.toggleAttribute('data-bottom-task', task);
  // The reminder slides to the new reach (250 ms); measure once more when it has arrived.
  if (reach !== lastReach) {
    lastReach = reach;
    clearTimeout(settle);
    settle = setTimeout(schedule, 320);
  }

  const host = document.querySelector('shopify-chat');
  if (!host) return;
  // Where the launcher rests on its own (its button lives in the widget's shadow root): its box
  // minus the lift it has right now, read from the computed transform so a lift still sliding
  // counts as what it is at this moment.
  const button = host.shadowRoot?.querySelector('button');
  if (button) {
    const t = getComputedStyle(host).transform;
    const ty = t && t !== 'none' ? new DOMMatrixReadOnly(t).m42 : 0;
    rest = window.innerHeight - (button.getBoundingClientRect().bottom - ty);
  }
  let lane = reach;
  const pill = [...document.querySelectorAll(PILL)].find((el) => !el.hidden);
  if (button && pill && !pill.hidden && !task && !pill.classList.contains('is-covered')) {
    const a = pill.getBoundingClientRect();
    const b = button.getBoundingClientRect();
    // Where it is now, or where it is heading when it is still sliding up to the bars.
    if (a.right > b.left && a.left < b.right) {
      lane = Math.max(lane, window.innerHeight - a.top, reach + PILL_GAP + pill.offsetHeight);
    }
  }
  const px = lane > 0 ? Math.max(Math.ceil(lane + GAP - rest), 0) : 0;
  host.dataset.lift = String(px);
  host.style.setProperty('--shopify-agent-activator-offset', px ? `${px}px` : '');
  host.style.transition = 'transform 250ms ease';
  host.style.transform = px ? `translateY(-${px}px)` : '';
  // Where the launcher lands with this lift, and whether a buy button is there.
  let covering = false;
  if (button) {
    const b = button.getBoundingClientRect();
    const bottom = window.innerHeight - rest - px;
    const top = bottom - b.height;
    covering = [...document.querySelectorAll(AVOID)].some((el) => {
      const r = el.getBoundingClientRect();
      return r.width > 0 && r.bottom > top - 4 && r.top < bottom + 4 && r.right > b.left && r.left < b.right;
    });
  }
  const hide = !!document.querySelector('dialog[open]') || covering;
  host.style.visibility = hide ? 'hidden' : '';
}

const schedule = () => {
  if (!frame) frame = requestAnimationFrame(place);
};

new MutationObserver(schedule).observe(document.body, {
  subtree: true,
  childList: true,
  attributes: true,
  attributeFilter: ['class', 'open', 'hidden'],
});
window.addEventListener('resize', schedule, { passive: true });
// A section that changes height without a class change (the contact form's step swap) says so.
document.addEventListener('mw:layout', schedule);
// A sticky bar lands on or leaves the bottom edge, and the buy buttons pass under the launcher as the page scrolls.
window.addEventListener('scroll', () => document.querySelector(`${STICKY_BARS}, ${AVOID}`) && schedule(), { passive: true });
document.addEventListener('transitionend', (event) => {
  if (event.target.matches?.(`mw-mobile-dock, mw-sticky-cart, ${PILL}`)) schedule();
});
schedule();
